export class AssignUserOnBehalf {
     BehalfID!: Number;
     BehalfCAI!: string;
     BehalfName!: string;
     CreatedDate ? : Date;
     CreatedBy!: string;
     UpdatedDate ? : Date;
     UpdatedBy ?: string;
     IsActive ? :  Boolean;
     FromDate ? : string;
     ToDate ? :string;
}
